module.exports = __webpack_public_path__ + "img/Location.85ad3ad1.svg";